import { Component, EventEmitter, Input, Output } from "@angular/core";
import { IFaxFolder } from "src/app/models/fax/fax-folder";

@Component({
  selector: "app-fax-folder-list",
  templateUrl: "./fax-folder-list.component.html",
  styleUrls: ["./fax-folder-list.component.scss"],
})
export class FaxFolderListComponent {
  @Input() items: IFaxFolder[] = [];
  @Input() isLoading = false;

  readonly skeletonRows = [1, 2, 3];

  @Output() createClick = new EventEmitter<string>();
  @Output() deleteClick = new EventEmitter<string>();

  selectedFolderName = "";
  isFolderSelected = false;

  selectFolder(folder: IFaxFolder) {
    this.selectedFolderName = folder.name ?? "";
    this.isFolderSelected = true;
  }

  onValueChange(value: string) {
    this.isFolderSelected = value === this.selectedFolderName && value.length > 0;
  }
}
